<template>
	<div class="ks-panel" :class="{ 'ks-panel-fill-height': fillHeight }">
		<div v-if="title || hasHeadingSlots" class="ks-panel-heading" :class="{ 'no-title': !title && !hasTitle}">
			<div v-if="hasTitle" class="ks-panel-title">
				<slot name="title">{{ title }}</slot>
			</div>
			<div v-if="hasLeftButtons" class="ks-panel-left-buttons">
				<slot name="left-buttons"></slot>
			</div>
			<div class="ks-panel-buttons">
				<slot name="buttons"></slot>
				<template v-if="searchable">
					<k-text-field
						style="width: 300px;"
						placeholder="Search"
						prepend-icon="search"
						hide-details
						clearable
						v-model="search_text">
					</k-text-field>
				</template>
				<template v-if="addable">
			      <k-btn color="primary" size="m" @click.stop="addButtonClicked"><k-icon>add</k-icon></k-btn>
				</template>
			</div>
		</div>
		<div v-if="hasBody" class="ks-panel-body" :class="panelBodyClasses">
			<slot></slot>
		</div>
		<div v-if="hasFooter" class="ks-panel-footer">
			<slot name="footer"></slot>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		"title": {
			type: String,
			default: ""
		},
		"searchable": {
			type: Boolean,
			default: false
		},
		"addable": {
			type: Boolean,
			default: false
		},
		"fillHeight": {
			type: Boolean,
			default: false
		},
		"bodyScrollable": {
			type: Boolean,
			default: true
		},
		"emitRoot": {
			type: Boolean,
			default: false
		},
		"emitType": {
			type: String,
			default: ""
		}
	},
	data () {
		return {
			search_text: "",
		}
	},
	watch: {
		"search_text": function(newVal, oldVal) {
			if (this.emitRoot) {
				this.$root.$emit(this.emitType +":search", newVal);
			}
			this.$emit("search", newVal);
		}
	},
	methods: {
		addButtonClicked () {
			if (this.emitRoot) {
				this.$root.$emit(this.emitType +":add");
			}
			this.$emit("add");
		}
	},
	computed: {
		"hasTitle" () {
			if(!!this.$slots["title"] || this.title.length > 0) return true;
			return false;
		},
		hasFooter () {
			return !!this.$slots.footer
		},
		"hasLeftButtons" () {
			return !!this.$slots["left-buttons"]
		},
		"hasHeadingSlots" () {
			return !!this.$slots.buttons || !!this.$slots["left-buttons"] || !!this.$slots.title
		},
		"hasBody" () {
			return !!this.$slots.default
		},
		panelBodyClasses () {
			return {
				"ks-panel-body-scrollable": this.fillHeight,
				"ks-panel-body-no-scroll": this.fillHeight && !this.bodyScrollable
			}
		}
	}
}
</script>
<style>
.ks-panel-fill-height {
	display: flex;
	flex-direction: column;
	height: 100%;
	min-height: 0;
	align-items: stretch;
}

.ks-panel-fill-height .ks-panel-heading,
.ks-panel-fill-height .ks-panel-footer {
	flex: 0 0 auto;
}

.ks-panel-fill-height .ks-panel-body.ks-panel-body-scrollable {
	flex: 1 1 auto;
	min-height: 0;
	display: flex;
	flex-direction: column;
	align-items: stretch;
	overflow-y: auto;
}

.ks-panel-fill-height .ks-panel-body.ks-panel-body-scrollable.ks-panel-body-no-scroll {
	overflow-y: hidden;
}

.ks-panel-footer {
	padding-left: 10px;
	padding-right: 10px;
}
</style>
